import { Carousel } from './Carousel';
import { useScreenSize } from '@hooks/useScreenSize';
import { CarouselCard } from './CarouselCard';

export const GenresCarousel = ({ genres, onCategoryClick }) => {
  const { isMobile } = useScreenSize();
  const renderGenre = (genreName: string) => {
    return (
      <CarouselCard
        title={genreName}
        imagePath={genres.find(g => g.name === genreName)?.genre_image || 'thumb_generic_flux_news.png'}
        isAvailable={true}
        onClick={() => onCategoryClick(genreName)}
        variant={isMobile ? 'mobile' : 'desktop'}
        centerText={true}
      />
    );
  };
  return <Carousel items={genres.map(genre => genre.name)} renderItem={renderGenre} itemHeight={isMobile ? '235px' : '280px'} gap={16} />;
};
